import type { JobQuestionDetail } from '@hemmafixa/shared';
import { Badge } from '@hemmafixa/ui';
import { useI18n } from '@/i18n/context';
import type { Messages } from '@/i18n/sv';

/** An answer as the person reads it: "Ja", "30 m²", the chosen option, or "Not answered". */
function answerText(question: Pick<JobQuestionDetail, 'answer' | 'answerType' | 'unit'>, t: Messages) {
  if (question.answer === null) return t.job.notAnswered;
  if (question.answerType === 'yes_no') return question.answer === 'yes' ? t.common.yes : t.common.no;
  if (question.answerType === 'number' && question.unit) return `${question.answer} ${question.unit}`;
  return question.answer;
}

/** The assistant's and admin's questions with their answers, each marked with who asked. */
export function JobQuestionList({ questions }: { questions: JobQuestionDetail[] }) {
  const { t } = useI18n();
  if (questions.length === 0) return <p className="text-sm text-muted-foreground">{t.job.noQuestions}</p>;
  return (
    <ul className="grid gap-4 text-sm">
      {questions.map((question) => (
        <li key={question.id} className="grid gap-1">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-xs font-medium text-muted-foreground">{question.question}</span>
            <Badge tone={question.source === 'admin' ? 'brand' : 'neutral'}>
              {question.source === 'admin' ? t.job.fromAdmin : t.job.fromAssistant}
            </Badge>
          </div>
          <p className={question.answer === null ? 'text-muted-foreground' : undefined}>
            {answerText(question, t)}
          </p>
        </li>
      ))}
    </ul>
  );
}
